import { jsxs, jsx } from 'react/jsx-runtime';
import { Button } from '@fabric-app/ui/components/Button';
import { Flex } from '@fabric-app/ui/components/Flex';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { styled } from 'styled-components';
import { useQueryResourcePublishDetails } from '../../queries/useQueryResourcePublishDetails.js';
import { LinkExternal } from '@fabric-app/ui/components/Link/LinkExternal';
import { resourceSharingModal } from '../ModalShare/resourceSharingStore.js';
import { useContextShareToken } from '../../contexts/AnonShareTokenContext.js';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';

const PublishedFlair = ({ resource, type }) => {
  const shareTokenContext = useContextShareToken();
  const { isXSView } = useResponsive();
  const publishedResourceId = resource.publishedAncestors?.[0]?.resourceId || resource.id;
  const { data: publishDetails } = useQueryResourcePublishDetails(publishedResourceId, {
    enabled: shareTokenContext?.type === void 0
  });
  if (!publishDetails || !!shareTokenContext) return null;
  const url = new URL(publishDetails.url, window.location.origin);
  if (publishedResourceId !== resource.id) {
    url.searchParams.set("fid", resource.id);
  }
  return /* @__PURE__ */ jsxs(FlairContainer, {
    children: [
      "This ",
      type,
      " is published ",
      isXSView ? "" : "and live",
      /* @__PURE__ */ jsxs(Flex, {
        alignItems: "center",
        gap: 8,
        children: [
          /* @__PURE__ */ jsx(Button, {
            variant: "bg-primary-text-app-primary",
            size: "xs",
            as: LinkExternal,
            href: url.toString(),
            children: "Visit URL"
          }),
          /* @__PURE__ */ jsx(Button, {
            variant: "bg-primary-text-app-primary",
            size: "xs",
            onClick: () => {
              resourceSharingModal.open({
                resourceId: resource.id,
                tab: "publish"
              });
            },
            children: "Manage"
          })
        ]
      })
    ]
  });
};
const FlairContainer = styled.div.withConfig({
  displayName: "PublishedFlair__FlairContainer",
  componentId: "sc-4580f77f-0"
})([
  `display:flex;align-items:center;gap:0.75rem;background-color:rgba(`,
  `,0.1);height:2.5rem;padding:0 0.75rem;justify-content:center;color:`,
  `;font-size:0.875rem;font-weight:500;flex-shrink:0;flex-grow:0;`
], cssVar["color-app-primary-rgb"], cssVar["color-app-primary"]);

export { PublishedFlair };
//# sourceMappingURL=PublishedFlair.js.map
